const TOAST_MESSAGES = {
  SUCCESS: "Success!",
  ERROR: "An error occurred. Please try again later.",
  AI_RESPONSE_ERROR: "Something went wrong. Please try again later",
  NETWORK_ERROR: "Network error. Please check your internet connection.",
  LOGIN_SUCCESS: "Login successful!",
  LOGOUT_SUCCESS: "Logout successful!",
  PASSWORD_CHANGED: "Password changed successfully!",
  USER_DETAILS_ERROR: "Failed to get user details",
  FAILURE_UPLOAD_DOCUMENT: "Failed to Upload document. Please try again later.",
  SUCCESS_UPLOAD_DOCUMENT: "Document uploaded successfully!",
  FAILURE_GET_DOCUMENTS: "Failed to get documents.",
  FAILURE_DELETE_DOCUMENT: "Failed to delete document. Please try again later.",
  FAILURE_GET_USERS: "Failed to get users. Please try again later.",
  FAILURE_BLOGS: "Failed to get blogs, please try again later.",
  FAILURE_BLOG: "Failed to get blog, please try again later.",
  DEFAULT_ERROR: "Well, that didn’t go as planned. Try again later!",
};

const categories = [
  "Technology",
  "Insights",
  "Fitness",
  "Artificial Intelligence",
  "Entertainment",
  "Politics",
  "International",
  "News",
  "Sports",
  "Fashion",
  "Food & Health",
  "Gaming",
  "Arts",
  "Travel",
];
const inspirationalQuotes = [
  {
    text: "Write with clarity, revise with courage, and publish with purpose.",
    author: "AAPMOR Blogs",
  },
  {
    text: "The strongest stories are the ones that make complex things feel simple and human.",
    author: "Editorial Note",
  },
  {
    text: "A great draft does not start perfect. It starts honest.",
    author: "Writing Room",
  },
];

const OTP_LENGTH = 6;

const featureItems = [
  {
    icon: "ED",
    title: "Powerful editor",
    text: "Write and publish thoughtful stories in minutes.",
  },
  {
    icon: "BM",
    title: "Blog of the Month",
    text: "Get recognized for your strongest writing.",
  },
  {
    icon: "AI",
    title: "AI writing tools",
    text: "Speed up summaries, titles, and idea framing.",
  },
  {
    icon: "CM",
    title: "Community",
    text: "Share ideas with readers across the company.",
  },
];

const stats = [
  { value: "2.4K", label: "Stories published" },
  { value: "348", label: "Active writers" },
  { value: "18K", label: "Monthly reads" },
];

const policyHighlights = [
  "Publish only accurate, respectful, and work-appropriate content.",
  "Do not share confidential client, employee, financial, or security-sensitive information.",
  "Use only material you are authorized to publish and cite third-party sources where required.",
];

export {
  TOAST_MESSAGES,
  categories,
  inspirationalQuotes,
  OTP_LENGTH,
  featureItems,
  stats,
  policyHighlights,
};
